export default __webpack_public_path__ + "static/media/guest.86033422.jpg";